import { useContext } from 'react';
import { ToastContext } from './toast-context';

const useToastContext = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error('useToastContext must be within a ToastProvider');
    }

    return context;
};

export default useToastContext;
